<template>
  <div class="account-page">
    <div class="row">
      <div class="col-lg-4">
        <UserData />
        <Company />
      </div>
      <div class="col-lg-8">
        <!-- <div class="row">
          <div class="col-lg-6"><KeeperData /></div>
          <div class="col-lg-6"><SalesRep /></div>
        </div>-->
        <OrdersCharts />
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";

import AccountMenu from "./AccountMenu.vue";
import AccountPanel from "./AccountPanel.vue";
import UserData from "./UserData.vue";
import Company from "./Company.vue";
import KeeperData from "./KeeperData.vue";
import SalesRep from "./SalesRep.vue";
import OrdersCharts from "./OrdersCharts.vue";

export default {
  components: {
    AccountMenu,
    AccountPanel,
    UserData,
    Company,
    KeeperData,
    SalesRep,
    OrdersCharts
  },
  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/AccountPage.vue